export const Areas = ['後門', '黃金谷', '第二洞', '第一洞', '大禮堂', '音樂廳', '長巷', '鐘塔區', '校門口']
export const AreaRegions = {
  '後門':['地下一樓', '地下室台階', '地下二樓', '老人牆', '鱷魚岬', '美好的懸岩'],
  '黃金谷':['貓屋', '伸展台', '浪之外', '黃金岩', '黑岩', '傳奇岩', '比基尼洞穴', '塔岩', '龍船岩', '失落的龍塔'],
  '第二洞':['後院', '陽光面', '入口裂隙', '雨牆', '洞外岩壁'],
  '第一洞':['洞之上', '南面', '西面', '東北面', '外牆', '龍脊背面下半部', '龍脊背面上半部'],
  '大禮堂':['上龍脊', '南側(龍脊北面)', '大斜板', '西面', '凡登峽谷', '龍柱'],
  '音樂廳':['破碎面', '左面', '正面', '北面', '演奏台', '包廂', '鯨魚頭'],
  '長巷':['佈告欄', '長巷', '獨木橋畔'],
  '鐘塔區':['訓導處', '水池畔', '左鐘塔', '鐘塔', '總統頭像山', '短巷', '臨海面'],
  '校門口':['人面岩', '校門口', '門簷', '騙人的牆'],
}

export const StyleColors = {
  Sport:'rgba(33, 150, 243, 1)',
  Trad:'rgba(244, 67, 54, 1)',
}

export const GradeColors = {
  '5.3':'#CDDC39',
  '5.4':'#CDDC39',
  '5.5':'#CDDC39',
  '5.6':'#CDDC39',
  '5.7':'#CDDC39',
  '5.8':'#CDDC39',
  '5.9':'#CDDC39',
  '5.10':'#FFC107',
  '5.11':'#FF5722',
  '5.12':'#E91E63',
  '5.13':'#9C27B0',
  '5.14':'#000000',
  '5.?':'#CCC',
}


export const MarkerList = [
  'B01',
  'B02',
  'B03',
  'B04',
  'B05',
  'B06',
  'B07',
  'B08',
  'B09',
  'B10',
  'B11',
  'B12',
  'B13',
  'B14',
  'B15',
  'B16',
  'A01',
  'A02',
]


export const FirebaseConfig = {
  apiKey: "AIzaSyC6UDLfbg6Ue3UQ2icFhhtKAEotoRux4Qc",
  authDomain: "longdong.firebaseapp.com",
  databaseURL: "https://longdong.firebaseio.com",
  storageBucket: "project-2803619783974357321.appspot.com",
}



/** WEBPACK FOOTER **
 ** ./src/app/config.js
 **/